import AbstractAction from "../AbstractAction";

export default class ChangeCustomLabelAction extends AbstractAction {
    constructor(provider, label, input, labelText) {
        super(provider);

        this.label = label;
        this.input = input;
        this.labelText = labelText;
        this.oldValue = input.value() || '';
        this.newValue = this.oldValue;
    }

    update() {
        this.newValue = this.input.value() || '';
        this.label.text = this.newValue;
    }

    finish() {
        if (this.oldValue != this.newValue) {
            this.labelText.html(this.newValue);
            if (this.label.index == 0) {
                this.getTab('info').input.title.value(this.newValue);
            }
            super.finish();
        } else {
            this.actions.discard();
        }
    }

    undo() {
        this.label.text = this.oldValue;
    }

    redo() {
        this.label.text = this.newValue;
    }
}
